import React from "react";

import "./ChartControls.css";
import { ChartColumnIncreasing, ChartLine, ChartPie, ExternalLink, FileDown, FileInput, ImageDown } from "lucide-react";

const ChartControls = ({
  onGraphChange,
  onCaptureScreen,
  onExportPDF,
  showExportInput,
  onExportClick,
  onExportSubmit,
  buttonVisible,
  nameInputRef,
  setModalOpen,
  hideChartTypes = false,
  hideCustomDashboard = false
}) => {
  return (
    <div className="chart-controls">
      {!hideChartTypes && (
        <div className="chart-type-controls">
          {/* <button className="btn-frec btn btn-primary btn-sm" type="button" name="Pie" title="Pie" onClick={onGraphChange}>
            <ChartPie />
          </button> */}
          <button className="btn-frec btn btn-sm" name="Line" title="Line" type="button" onClick={onGraphChange}>
            <ChartLine />
          </button>
          <button className="btn-frec btn btn-sm" name="Bar" title="Bar" type="button" onClick={onGraphChange}>
            <ChartColumnIncreasing />
          </button>
        </div>
      )}

      <div className="export-controls">
        <button className="btn-frec btn btn-sm" title="Descargar captura" type="button" onClick={onCaptureScreen}>
          <ImageDown />
        </button>
        <button className="btn-frec btn btn-sm" title="Descargar gráfico en pdf" type="button" onClick={onExportPDF}>
          <FileDown />
        </button>

        {buttonVisible && (
          <button className="btn-frec btn btn-sm" type="button" title="Enviar gráfico a reportes" onClick={onExportClick}>
            <FileInput />
          </button>
        )}

        {!hideCustomDashboard && (
          <button className="btn-frec btn btn-sm" title="Enviar gráfico a tablero personalizado" type="button" onClick={() => setModalOpen(true)}>
            <ExternalLink />
          </button>
        )}

        {showExportInput && (
          <div className="export-input-container">
            <input
              type="text"
              name="name"
              ref={nameInputRef}
              placeholder="Ingrese nombre de referencia"
              className="export-name-input"
            />
            <button type="button" className="btn-frec btn btn-sm" title="Enviar" onClick={onExportSubmit}>
              <FileInput />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChartControls;
